export const compConfig = [
  {
    label: "组件类型",
    val: "",
    uiType: 3,
    editable: false,
    options: [
      { label: "单行文本", value: 1 },
      { label: "多行文本", value: 2 },
      { label: "单选列表", value: 3 },
      { label: "多选列表", value: 4 },
      { label: "日期组件", value: 6 },
    ],
    //   visiableOnly: true,
  },
  {
    label: "名称",
    val: "",
    uiType: 1,
    editable: true,
  },
  { label: "宽度", val: "", uiType: 1, editable: true },
  { label: "能否清空", val: "", uiType: 19, editable: true },
  { label: "能否禁用", val: "", uiType: 19, editable: true },
  { label: "能否搜索", val: "", uiType: 19, editable: true },
  { label: "是否必填", val: "", uiType: 19, editable: true },
];

const AtrributeReadOnlyCompList = [
  {
    label: "组件类型",
    val: 1,
    uiType: 3,
    editable: false,
    options: [{ label: "只读字段", value: 1 }],
    //   visiableOnly: true,
  },
  {
    label: "名称",
    val: "",
    uiType: 1,
    editable: true,
  },
  { label: "宽度", val: "", uiType: 1, editable: true },
];

const getCompConfigMapList = (id) => {
  let arr = [
    { label: "宽度", val: "", uiType: 1, editable: true },
    { label: "能否清空", val: "", uiType: 19, editable: true },
    { label: "能否禁用", val: "", uiType: 19, editable: true },
    { label: "是否必填", val: "", uiType: 19, editable: true },
  ];
  if (id === 3 || id === 4) {
    const list = [
      {
        label: "选择列表",
        val: "",
        uiType: 3,
        options: [],
        editable: true,
      },
      { label: "能否搜索", val: "", uiType: 19, editable: true },
    ];
    arr = [...list, ...arr];
  }
  return [
    {
      label: "组件类型",
      val: id,
      uiType: 3,
      editable: false,
      options: [
        { label: "单行文本", value: 1 },
        { label: "多行文本", value: 2 },
        { label: "单选列表", value: 3 },
        { label: "多选列表", value: 4 },
        { label: "日期组件", value: 6 },
      ],
      //   visiableOnly: true,
    },
    {
      label: "名称",
      val: "",
      uiType: 1,
      editable: true,
    },
    ...arr,
  ];
};

export const getCompConfig = (item) => {
  const { uiType, readOnlyAttribute } = item;
  if (readOnlyAttribute) {
    return AtrributeReadOnlyCompList;
  }
  console.log(uiType);

  const list = getCompConfigMapList(uiType);
  return list;
};

export const tableConfig = [
  { label: "表格名称", uiType: 1, val: "" },
  { label: "是否可视", uiType: 19, val: true },
];
